﻿export class File {
    private readonly _id: string;

    public get id(): string {
        return this._id;
    }

    private readonly _name: string;

    public get name(): string {
        return this._name;
    }

    constructor(id: string, name: string) {
        this._id = id;
        this._name = name;
    }
}
